import { SVGProps } from 'react';

const Checkmark = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.9974 0.166992C9.21915 0.166992 11.8307 2.77858 11.8307 6.00033C11.8307 9.22208 9.21915 11.8337 5.9974 11.8337C2.77565 11.8337 0.164062 9.22208 0.164062 6.00033C0.164062 2.77858 2.77565 0.166992 5.9974 0.166992ZM8.50398 3.83738L5.41406 6.92322L4.07648 5.58563C3.84898 5.35813 3.47973 5.35813 3.25165 5.58563C3.02356 5.81372 3.02356 6.18297 3.25165 6.41105L5.41348 8.57288L9.32881 4.6628C9.5569 4.4353 9.5569 4.06605 9.3294 3.83797C9.10131 3.61047 8.73206 3.60988 8.50398 3.83738Z"
        fill="#07D034"
      />
    </svg>
  );
};

export default Checkmark;
